// extracted by mini-css-extract-plugin
export default {"cardSpecificEventsList":"CardSpecificEventsList_cardSpecificEventsList__EPvo6","specialEventCard":"CardSpecificEventsList_specialEventCard__GBE1n"};